import { PAGE_TYPES } from '../../enums/page-types';
import getConfirmationWithVariables from '../../services/slate/getConfirmationWithVariables';
import { loadSlateContent } from '../../services/slate/load-slate-content';

export function getContent({ checkout, charge, email }) {
  if (checkout.redirectAfterPayment && checkout.redirectUrl) {
    if (checkout.customizeCheckoutConfirmation) {
      return {
        title: checkout.confirmationCheckoutTitle,
        message: checkout.confirmationCheckoutMessage,
      };
    }

    const defaultConfirmation = getDefaultConfirmation({
      checkout,
      charge,
      email,
    });

    return {
      title: defaultConfirmation.title,
      message: `${defaultConfirmation.message}

      You will be redirected in a few seconds.`,
    };
  }

  if (checkout.customizeCheckoutConfirmation) {
    return {
      title: checkout.confirmationCheckoutTitle,
      message: checkout.confirmationCheckoutMessage,
    };
  }

  const defaultConfirmation = getDefaultConfirmation({
    checkout,
    charge,
    email,
  });

  return defaultConfirmation;
}

export function getDefaultConfirmation({ charge, checkout, email }) {
  if (checkout.type === PAGE_TYPES.FORM) {
    if (checkout.sendEmailConfirmation) {
      return {
        title: 'Submission confirmed!',
        message: `Thanks for your submission. You will receive an email confirmation shortly${
          email ? ` at ${email}` : '.'
        }`,
      };
    } else {
      return {
        title: 'Submission confirmed!',
        message: 'Thanks for your submission.',
      };
    }
  }

  if (charge.amount <= 0) {
    if (checkout.sendEmailConfirmation) {
      return {
        title: 'Submission confirmed!',
        message: `Thanks for your submission. You will receive an email confirmation shortly${
          email ? ` at ${email}` : '.'
        }`,
      };
    } else {
      return {
        title: 'Submission confirmed!',
        message: 'Thanks for your submission.',
      };
    }
  } else {
    if (checkout.sendEmailConfirmation) {
      return {
        title: 'Payment confirmed!',
        message: `Thanks for your payment. You will receive an email confirmation shortly${
          email ? ` at ${email}` : '.'
        }`,
      };
    } else {
      return {
        title: 'Payment confirmed!',
        message: 'Thanks for your payment.',
      };
    }
  }
}

export function getCheckoutConfirmation({ checkout, charge, seller, email }) {
  const { title, message } = getContent({ checkout, charge, email });

  const { html, text } = parseConfirmationMessage(message, {
    charge,
    seller,
    checkout,
  });

  return {
    title: charge.livemode ? title : `[TEST] ${title}`,
    message: html || text,
    type: html ? 'html' : 'text',
  };
}

export function parseConfirmationMessage(message, { charge, seller, checkout }) {
  try {
    const parsedValue = typeof message === 'string' ? JSON.parse(message) : message;
    const content = loadSlateContent(parsedValue);

    return {
      html: getConfirmationWithVariables(content, charge, seller, checkout),
    };
  } catch (e) {
    return {
      text: message,
    };
  }
}
